export const minifyJS = (code: string) => {
  return (
    code
      // Убираем комментарии /* */
      .replace(/\/\*[\s\S]*?\*\//g, '')
      // Убираем комментарии //
      .replace(/\/\/.*$/gm, '')
      // Убираем лишние пробелы
      .trim()
      .replace(/\s+/g, ' ')
      // Убираем пробелы вокруг операторов и пунктуации
      // .replace(/\s*([=+\-*/%&|^<>!?:;,{}()[\]])\s*/g, '$1')
      // Убираем переносы строк
      .replace(/\n/g, '')
      // Убираем табуляции
      .replace(/\t/g, '')
    // Убираем лишние пробелы после точек с запятой
    // .replace(/;\s+/g, ';')
    // Убираем пробелы после запятых
    // .replace(/,\s+/g, ',')
    // Убираем лишние пробелы
    // .replace(/\s+/g, ' ')
  );
};
